var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6892 11.6487L15.6855 1.37362C15.6855 0.574295 15.1563 0.0241699 14.3328 0.0241699H4.05444C3.28818 0.0241699 2.73248 0.605043 2.73248 1.28931C2.73248 1.97032 3.32313 2.51766 4.02974 2.51766H7.74321L11.7117 2.37648L9.87706 3.99825L0.420613 13.4719C0.154642 13.7444 0 14.0714 0 14.4045C0 15.0757 0.616725 15.7064 1.30194 15.7064C1.64197 15.7064 1.96198 15.5658 2.23447 15.2895L11.7082 5.82934L13.3439 3.98766L13.1887 7.80941V11.6734C13.1887 12.3833 13.7328 12.9776 14.4208 12.9776C15.1083 12.9776 15.6892 12.3945 15.6892 11.6487Z",
    fill: "#344BBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.b18aa9190346fc3c75162fcdda56bb61.svg";
export { ForwardRef as ReactComponent };